import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

export const HOLD_SPEED = 2;

export interface SpeedStore {
  isHoldingSpace: boolean;
  setHoldingSpace(v: boolean): void;
  invertColors: boolean;
  setInvertColors(v: boolean): void;
  showStats: boolean;
  setShowStats(v: boolean): void;
  mirrorVideo: boolean;
  setMirrorVideo(v: boolean): void;
}

export const useSpeedStore = create(
  immer<SpeedStore>((set) => ({
    isHoldingSpace: false,
    setHoldingSpace(v: boolean) {
      set((s) => {
        s.isHoldingSpace = v;
      });
    },
    invertColors: false,
    setInvertColors(v: boolean) {
      set((s) => {
        s.invertColors = v;
      });
    },
    showStats: false,
    setShowStats(v: boolean) {
      set((s) => {
        s.showStats = v;
      });
    },
    mirrorVideo: false,
    setMirrorVideo(v: boolean) {
      set((s) => {
        s.mirrorVideo = v;
      });
    },
  })),
);
